interface ReportData {
  fileName: string,
  dateFormat: string,
  startDate: string,
  endDate?: string
  content: any | undefined
}

enum Reports {
  cardBalanceReport = 'cardBalanceReport',
  chargeLimitReport = 'chargeLimitReport',
  chargeReport = 'chargeReport',
  trxErrorReport = 'trxErrorReport',
  salesReport = 'salesReport'
}

export {
  ReportData,
  Reports
}
